import * as Dialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { Icon } from "./icons";
import { useFocusReturn } from "./focusReturn";
import s from "./overlay.module.css";

export interface DrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/** Right-hand panel, 500px wide (full width on a phone). Radix Dialog gives the focus trap, Esc and focus return. */
export function Drawer({ open, onOpenChange, title, description, children, footer }: DrawerProps) {
  const focus = useFocusReturn();
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={s.scrim} />
        <Dialog.Content className={s.drawer} aria-describedby={description ? undefined : undefined} {...focus}>
          <header className={s.dhead}>
            <div>
              <Dialog.Title asChild><h2>{title}</h2></Dialog.Title>
              {description ? <Dialog.Description asChild><p>{description}</p></Dialog.Description> : null}
            </div>
            <Dialog.Close className={s.close} aria-label="Close"><Icon name="x" /></Dialog.Close>
          </header>
          <div className={s.dbody}>{children}</div>
          {footer ? <footer className={s.dfoot}>{footer}</footer> : null}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
